(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("luna-toolbar"));
	else if(typeof define === 'function' && define.amd)
		define(["luna-toolbar"], factory);
	else if(typeof exports === 'object')
		exports["LunaPainter"] = factory(require("luna-toolbar"));
	else
		root["LunaPainter"] = factory(root["LunaToolbar"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__114__) {
return 